import React, {useContext, useEffect, useState} from 'react'
import styled from "styled-components";
import {GlobalDataContext} from "../../contexts/GlobalDataContext";
import SplashContainer from "./SplashContainer";
import MainContent from "./MainContent";

const MainContainerDiv = styled.div`
    @media (min-width: 481){
        display: flex;
        flex-direction: row;
    }

    @media (max-width: 480px) {
        display: flex;
        flex-direction: column;
        flex: 1;
        width: 100vw;
        height: 100%;
        min-height: 100%;
        box-sizing: border-box;
        overflow-x: hidden;
        overflow-y: hidden;
    }
`;

const MainContainer: React.FC = () => {
    const [show, setShow] = useState(false);
    const [showSplash, setShowSplash] = useState(true);
    const [displayValue, setDisplayValue] = useState('flex');

    // @ts-ignore
    const {allDataLoaded} = useContext(GlobalDataContext);

    useEffect(() => {
        setShow(allDataLoaded);

        if (allDataLoaded) {
            setTimeout(() => {
                setShowSplash(false);
                setDisplayValue('none')
            }, 1500)
        }
    }, [allDataLoaded]);

    useEffect(() => {
        setDisplayValue('flex');
    }, [displayValue]);

    return (
            <MainContainerDiv id="MAIN CONTAINER" style={{display: displayValue}}>
                { showSplash ? <SplashContainer show={show}/> : <MainContent /> }
            </MainContainerDiv>
    );
};

export default MainContainer;
